import axios from "axios";
import env from "../variables/EndpointEnvironment";
const headers = {
  "Content-Language": localStorage.getItem('i18nextLng'),
}
const PrivacyAnnouncementAPI = () => {
  return axios.get(
    `${env.HOST}/pemberitahuan-privasi`,
    {
      headers
    }
  );
};
export default PrivacyAnnouncementAPI;
